import { render, staticRenderFns } from "./DataSetForm.vue?vue&type=template&id=33d9354c"
import script from "./DataSetForm.vue?vue&type=script&lang=js"
export * from "./DataSetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d9354c')) {
      api.createRecord('33d9354c', component.options)
    } else {
      api.reload('33d9354c', component.options)
    }
    module.hot.accept("./DataSetForm.vue?vue&type=template&id=33d9354c", function () {
      api.rerender('33d9354c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/database/datamodel/DataSetForm.vue"
export default component.exports